import { render, staticRenderFns } from "./AttachmentsColumn.vue?vue&type=template&id=671e384e"
import script from "./AttachmentsColumn.vue?vue&type=script&lang=js"
export * from "./AttachmentsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports